import script from "./TaskView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskView.vue?vue&type=script&setup=true&lang=js"

import "./TaskView.vue?vue&type=style&index=0&id=91a82a52&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91a82a52"]])

export default __exports__